import {Component, Inject, OnInit} from '@angular/core';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataARClaimListModel} from '../../models/data-ar-claim-list';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {DataARClaimItemListModel} from '../../models/data-ar-claim-item-list';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {AdditionalInfo, DataARClaimModel} from '../../../../models/accountsReceivable/data-ar-claim.model';
import {ClaimStatusEnum} from '../../../../models/enum/claim-status.enum';
import {RecallClaimModel} from '../../models/recall-claim.model';
import {Globals} from '../../../../globals';
import {ValidationLogItem} from '../../models/ValidationLogItem.model';
import {ClaimValidationDetailComponent} from '../claim-validation-detail/claim-validation-detail.component';
import {ImagePickerDialogComponent} from '../../../../dialog/image-picker-dialog/image-picker-dialog.component';
import {DataARClaimAttachmentModel} from '../../../../models/accountsReceivable/data-ar-claim-attachments.model';
import {DocumentInFolderDataModel} from '../../../../models/document/document-in-folder-data.model';
import {ReportGlobalParametersModel} from "../../../reports/models/ReportGlobalParameters.model";
import {ReportStartUpInstructionsModel} from "../../../reports/models/ReportStartUpInstructions.model";
import {ReportStartUpObjectModel} from "../../../reports/models/ReportStartUpObject.model";
import {
  ReportAdaParametersComponent
} from "../../../reports/report-viewer-parameters/report-ada-parameters/report-ada-parameters.component";
import {ReportADAExtraParams} from "../../../reports/models/ReportADAExtraParamsModel.model";
import {ClaimMethodEnum} from '../../../../models/enum/notification/claim-method.enum';
import { NarrativeNoteDialogComponent } from '../narrative-note-dialog/narrative-note-dialog.component';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import {UpdateClaimItemCommentModel} from '../../models/update-claim-item-comment.model';

@Component({
  selector: 'app-claim-view',
  templateUrl: './claim-view.component.html',
  styleUrls: ['./claim-view.component.css']
})
export class ClaimViewComponent implements OnInit {

  dataClaim: DataARClaimListModel;
  dataClaimItems: DataARClaimItemListModel[] = [];
  dataClaimAttachments: DataARClaimAttachmentModel[] = [];
  numClaimAttachmentsSent: number = 0;
  numNarrativesSent: number = 0;
  searchPredicate: (data: any, filter: string) => boolean;
  isLoading: boolean = false;
  ARClaimID: string = '9000000A-1000-0000-0000-000000000001';
  enumClaimStatusID: string;
  enumClaimCheckStatusID: string;
  ADAClaimFormReportID: string;
  isRadioGroupDisabled: boolean = false;
  cancelReason: string = '';
  isManagementMode: boolean;
  isCancelled: boolean = false;
  dxResponse: any;
  reportADAExtraParams: ReportADAExtraParams;
  patientId: string;
  AdditionalInfo: AdditionalInfo;
  ClaimItemComment: string;
  ClaimItemCommentEdit: boolean = false;
  ClaimItemCommentClaimItemID: string;
  commentForToothCode: string;


  enumClaimStatusIDReadyToSend: string = ClaimStatusEnum.ReviewedReadyToSend;
  enumClaimStatusIDRecall: string = ClaimStatusEnum.Canceled;

  enumClaimCheckStatusNotChecked: string = '00000208-1000-0000-0000-000000000001';
  enumClaimCheckStatusProblem: string = '00000208-1000-0000-0000-000000000002';
  enumClaimCheckStatusPass: string = '00000208-1000-0000-0000-000000000003';

  enumClaimAttachmentStatusAdded: string = '00000541-1000-0000-0000-000000000001';
  enumClaimAttachmentStatusSent: string = '00000541-1000-0000-0000-000000000002';
  enumClaimAttachmentTypeDocument: string = '00000542-1000-0000-0000-000000000001';
  enumClaimAttachmentTypeNarrative: string = '00000542-1000-0000-0000-000000000002';
  emptyADAParameters: ReportADAExtraParams;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ClaimViewComponent>,
    public globals: Globals,
    private readonly printService: TDOPrintService
  ) {
    this.searchPredicate = (searchData: DataARClaimItemListModel, filter: string) => {
      if ((!searchData.ToothName ? '' : searchData.ToothName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.ProcedureName ? '' : searchData.ProcedureName).toLowerCase().includes(filter)) {
        return true;
      }
      else if ((!searchData.Code ? '' : searchData.Code).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };

    this.ADAClaimFormReportID = '9000000A-1000-0000-0000-000000000001';

    this.emptyADAParameters = {
      diagCodeListQualifierA: '',
      diagCodeListQualifierB: '',
      diagCodePrimA: '',
      diagCodePrimB: '',
      diagCodePrimC: '',
      diagCodePrimD: '',
      remarks: '',
    };
  }

  async ngOnInit() {

    // testing
    this.isManagementMode = false;

    // show loading
    this.isLoading = true;

    // set vars
    if (this.data) {

      // arclaimid
      if (this.data.ARClaimID) {
        this.ARClaimID = this.data.ARClaimID;
      }

      // claim status
      if (this.data.enumClaimStatusID) {
        this.enumClaimStatusID = this.data.enumClaimStatusID;
      }

      // claim check status
      if (this.data.enumClaimCheckStatusID) {
        this.enumClaimCheckStatusID = this.data.enumClaimCheckStatusID;
      }
    }

    // if claimid exists, load rest of component
    if (this.ARClaimID) {

      // get claim data
      const promises: any[] = [
        this.arService.getClaimItemList(this.ARClaimID).toPromise(),
        this.arService.getClaimAttachements(this.ARClaimID).toPromise(),
        this.arService.getClaimDetails(this.ARClaimID).toPromise(),
      ];
      const results: any[] = await Promise.all(promises);
      this.dataClaimItems = results[0];
      this.dataClaimAttachments = results[1];
      this.dataClaim = results[2];

      // if additionalJson does not contains  ADAParameter  then include it
      let additionalInfo = JSON.parse(this.dataClaim.AdditionalInfoJSON);
      if(additionalInfo === null || additionalInfo === undefined) {
        additionalInfo = {
          dxcClaimId: '',
          dxcAttachmentId:'',
          ADAParameters: this.emptyADAParameters
        };
      }
      else if (additionalInfo.hasOwnProperty('ADAParameters') === false || additionalInfo.ADAParameters === null) {
        additionalInfo.ADAParameters = this.emptyADAParameters;

      }
      this.dataClaim.AdditionalInfoJSON = JSON.stringify(additionalInfo);
      // set claim enums
      this.enumClaimStatusID = this.dataClaim.enumClaimStatusID;
      this.enumClaimCheckStatusID = this.dataClaim.enumClaimCheckStatusID;

      this.numClaimAttachmentsSent = this.dataClaimAttachments.filter(b => b.enumClaimAttachmentTypeID === this.enumClaimAttachmentTypeDocument).length;
      this.numNarrativesSent = this.dataClaimAttachments.filter(b => b.enumClaimAttachmentTypeID === this.enumClaimAttachmentTypeNarrative).length;

      this.isLoading = false;
    }

    // handle statuses
    if (this.enumClaimStatusID === ClaimStatusEnum.Sent || this.enumClaimStatusID === ClaimStatusEnum.Sending || this.enumClaimStatusID === ClaimStatusEnum.Closed) {
      this.isRadioGroupDisabled = true;
    }
    if (this.enumClaimStatusID === ClaimStatusEnum.Canceled) {
      this.isCancelled = true;
    }

    // kickoff claim validation
    if (this.dataClaim.enumClaimStatusID === ClaimStatusEnum.Created || this.dataClaim.enumClaimStatusID === ClaimStatusEnum.PendingReview || this.dataClaim.enumClaimStatusID === ClaimStatusEnum.SendError) {

      // show alert about running claim validation..
      this.createMessage('Validating claim with DentalXChange', 'Running...');

      if (this.dataClaim.enumClaimMethodID === ClaimMethodEnum.APIDX) {
        this.checkClaim();
      }
      else {
        // show alert about running claim validation..
        this.createMessage('Validating claim for ADA Form', 'Running...');

        this.checkClaimInternalOnly();
      }
    }

    // patientid
    if (this.dataClaim) {
      this.patientId = this.dataClaim.PatientID;
    }
  }

  onRowSelected($event: TdoTableSelectionEvent) {
    this.ClaimItemComment = $event.row.model.Comment; // $event.row.model.Comment ? $event.row.model.Comment : '';
    this.ClaimItemCommentEdit = false;
    this.ClaimItemCommentClaimItemID = $event.row.model.ARClaimItemID;

    // update comment prompt
    this.commentForToothCode = ($event.row.model.TeethReference ? $event.row.model.TeethReference : '') + '' + ($event.row.model.Code ? $event.row.model.Code : '');
    if (this.commentForToothCode.trim()) {
      this.commentForToothCode = ' for ' + this.commentForToothCode;
    }
  }

  async showADAFormDialog() {
    const reportGlobalParameters = new ReportGlobalParametersModel();
    reportGlobalParameters.LOCID = this.globals.LOCID;
    reportGlobalParameters.PatientID = this.dataClaim.PatientID;
    reportGlobalParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
    reportGlobalParameters.ARClaimID = this.ARClaimID;
    try {
          let documentID = await this.printService.printReport( ReportIDEnum.reportID_ARClaim, reportGlobalParameters).toPromise();
          this.printService.executePrint([documentID]);
        }
    catch (error) {
      this.createMessage('Error when trying to print Document.', 'error');
    }
  }

  showADAParameters(){
    const ReportADAParams = this.reportADAExtraParams;
    const AdditionalConfig = new AdditionalInfo();
    let reportADAParams: any;
    if (this.reportADAExtraParams !== undefined) {
       reportADAParams = {
        diagCodeListQualifierA: this.reportADAExtraParams.diagCodeListQualifierA,
        diagCodeListQualifierB: this.reportADAExtraParams.diagCodeListQualifierB,
        diagCodePrimA: this.reportADAExtraParams.diagCodePrimA,
        diagCodePrimB: this.reportADAExtraParams.diagCodePrimB,
        diagCodePrimC: this.reportADAExtraParams.diagCodePrimC,
        diagCodePrimD: this.reportADAExtraParams.diagCodePrimD,
        remarks: this.reportADAExtraParams.remarks
      };
    }
    this.AdditionalInfo =  JSON.parse(this.dataClaim.AdditionalInfoJSON);
    const config = new MatDialogConfig();
    config.width = '600px';
    config.height = '600px';
    config.data = {

      AdditionalInfo: JSON.parse(JSON.stringify(this.AdditionalInfo))
    };

    const adaParametersReport = this.dialog.open(ReportAdaParametersComponent, config);

    adaParametersReport.afterClosed().subscribe(result => {
      if (result) {
        // results returned
        this.reportADAExtraParams = new ReportADAExtraParams();
        this.reportADAExtraParams = result;
        this.dataClaim.AdditionalInfoJSON =    JSON.stringify(result);
        if(this.dataClaim.ARClaimID === undefined || this.dataClaim.ARClaimID === null){
          this.dataClaim.ARClaimID = this.ARClaimID;
        }
        AdditionalConfig.ADAParameters = this.reportADAExtraParams;
        this.arService.saveDataClaimAdditionalInfoJSON(this.dataClaim, AdditionalConfig).toPromise();
      }
    });
  }

  closeRef(payload: boolean = false) {
    this.dialogRef.close(payload);
  }

  SaveClaimStatus() {
    this.isLoading = true;

    // if recall was selected
    if (this.enumClaimStatusID === this.enumClaimStatusIDRecall) {
      if (this.cancelReason.trim() === '') {
        this.createMessage('Please provide a reason for voiding the claim', 'Error');
        this.isLoading = false;
      }
      else {
        this.recallClaim();
      }
    }
    else {
      // save enumClaimStatusID
      const claim = new DataARClaimModel();
      claim.ARClaimID = this.ARClaimID;
      claim.enumClaimStatusID = this.enumClaimStatusID;
      this.arService.saveClaimStatus(claim)
        .subscribe(response => {
            this.isLoading = false;
            this.closeRef();
          },
          err => {
            // show error
          });
    }
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  checkClaim() {
    // alert('check claim ...');
    this.isLoading = true;
    this.arService.getDXClaimValidationResult(this.ARClaimID)
      .subscribe(response => {

          // read response
          this.dxResponse = response;
          this.isLoading = false;
          if (response.ErrorStatus === 0) {
            // validation appears to have succeeded
            // this.showMessage('Success', response);
            this.showMessage('Success', 'Internal & Dental Exchange Validation Succeeded');

            // update enumClaimCheckStatusID status to passed
            this.enumClaimCheckStatusID = this.enumClaimCheckStatusPass;
          }
          else {
            // show our claim validation window
            this.openClaimValidationDetail(response.ValidationLogItems, false);

            // update enumClaimCheckStatusID status to problem
            this.enumClaimCheckStatusID = this.enumClaimCheckStatusProblem;
          }

          // update enumClaimCheckStatus in DB
          const claim = new DataARClaimModel();
          claim.ARClaimID = this.ARClaimID;
          claim.enumClaimCheckStatusID = this.enumClaimCheckStatusID;
          this.isLoading = true;
          this.arService.saveClaimCheckStatus(claim)
            .subscribe(checkResponse => {
                this.isLoading = false;
                this.refreshAttachments();
              },
              err => {
                // show error
              });

          // this.closeRef();
        },
        err => {
          // show error
        });
  }

  checkClaimInternalOnly() {
    // alert('check claim ...');
    this.isLoading = true;
    this.arService.getInternalClaimValidationResult(this.ARClaimID)
      .subscribe(response => {

          // read response
          this.dxResponse = response;
          this.isLoading = false;

          if (response.ErrorStatus === 0) {
            // validation appears to have succeeded
            this.showMessage('Success', 'Internal Validation Succeeded');

            // update enumClaimCheckStatusID status to passed
            this.enumClaimCheckStatusID = this.enumClaimCheckStatusPass;
          }
          else {
            // show our claim validation window
            this.openClaimValidationDetail(response.ValidationLogItems, true);

            // update enumClaimCheckStatusID status to problem
            this.enumClaimCheckStatusID = this.enumClaimCheckStatusProblem;
          }

          // update enumClaimCheckStatus in DB
          const claim = new DataARClaimModel();
          claim.ARClaimID = this.ARClaimID;
          claim.enumClaimCheckStatusID = this.enumClaimCheckStatusID;
          this.isLoading = true;
          this.arService.saveClaimCheckStatus(claim)
            .subscribe(checkResponse => {
                this.isLoading = false;
              },
              err => {
                // show error
              });
        },
        err => {
          // show error
        });
  }

  openClaimValidationDetail(items: ValidationLogItem[], internal: boolean) {

    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '675px';
    config.data = {
      ValidationLogItems: items,
      Internal: internal
    };
    config.panelClass = 'dialog';

    const reportViewer = this.dialog.open(ClaimValidationDetailComponent, config);

    reportViewer.afterClosed().subscribe(result => {
      // no action
    }, err => {
      // reject(err);
    });
  }

  manageAttachments() {
    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '572px';
    config.data = {
      PatientId: this.dataClaim.PatientID,
      ARClaimID: this.ARClaimID
    };
    config.panelClass = 'dialog';

    const imagePicker = this.dialog.open(ImagePickerDialogComponent, config);
    imagePicker.afterClosed().subscribe(result => {
      if (result) {
        // results returned
        const images: DocumentInFolderDataModel[] = result;
        const attachmentsToSave: DataARClaimAttachmentModel[] = [];
        const attachmentsToRemove: DataARClaimAttachmentModel[] = [];
        images.forEach(a => {
          if (a.dataDocument.ParentDocumentID) {
            const docExists = this.dataClaimAttachments.find(b => b.DocumentID === a.dataDocument.ParentDocumentID);
            if (!docExists) {
              const attachment = new DataARClaimAttachmentModel();
              attachment.ARClaimID = this.ARClaimID;
              attachment.DocumentID = a.dataDocument.ParentDocumentID;
              attachment.enumClaimAttachmentStatusID = this.enumClaimAttachmentStatusAdded;
              attachment.enumClaimAttachmentTypeID = this.enumClaimAttachmentTypeDocument;
              attachment.StatusOn = new Date();

              // add document to save
              attachmentsToSave.push(attachment);
            }
          }
        });

        // loop through existing added claim attachments, and if no longer selected delete them in db
        // filter this.dataClaimAttachments by added
        // then cross check with results to see if anything was unselected
        // add to this.attachmentsToRemove
        this.dataClaimAttachments.forEach(a => {
          const att = images.find(b => a.DocumentID === b.dataDocument.ParentDocumentID);
          if (a.enumClaimAttachmentStatusID === this.enumClaimAttachmentStatusAdded && !att && a.enumClaimAttachmentTypeID === this.enumClaimAttachmentTypeDocument ) {
            attachmentsToRemove.push(a);
          }
        });

        // add documents to db
        if (attachmentsToSave.length > 0) {
          this.arService.saveClaimAttachements(attachmentsToSave)
            .subscribe(response => {
                // add to model
                if (response) {
                  response.forEach(a => {
                    this.dataClaimAttachments.push(a);
                  });

                  // update claim validation status
                  this.updateClaimValidationStatus();
                }
              },
              err => {
                // show error
              });
        }

        // remove documents
        if (attachmentsToRemove.length > 0) {
          this.arService.removeClaimAttachements(attachmentsToRemove)
            .subscribe(responseRemove => {
                // remove from model
                if (responseRemove) {
                  attachmentsToRemove.forEach(rem => {
                    this.dataClaimAttachments = this.dataClaimAttachments.filter(a => a.DocumentID !== rem.DocumentID);
                    this.dataClaimAttachments = this.dataClaimAttachments;
                  });
                }

                // update claim validation status
                this.updateClaimValidationStatus();
              },
              err => {
                // show error
              });
        }
      }
    }, err => {
      // reject(err);
    });
  }

  returnAttachmentCount() {
    return this.dataClaimAttachments.filter(b => b.enumClaimAttachmentTypeID === this.enumClaimAttachmentTypeDocument).length;
  }

  recallClaim() {

    if (!this.isManagementMode) {
      this.cancelReason = 'User clicked cancel button';
    }

    // recall claim on server
    const payload = new RecallClaimModel();
    payload.ARClaimID = this.ARClaimID;
    payload.RecallReason = this.cancelReason;
    payload.PatientID = this.globals.currentPatientId;
    this.arService.recallClaim(payload)
      .subscribe(response => {
          // read response

          this.isLoading = false;
          this.closeRef(true);
        },
        err => {
          // show error
        });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 6000,
      verticalPosition: 'top',
    });
  }

  okButtonDisabled() {
    if (this.isCancelled || ((this.enumClaimCheckStatusID ? this.enumClaimCheckStatusID : '') !== this.enumClaimCheckStatusPass && (this.enumClaimStatusID ? this.enumClaimStatusID : '') !== this.enumClaimStatusIDRecall)) {
      return true;
    }
    else if ((this.enumClaimStatusID ? this.enumClaimStatusID : '') === this.enumClaimStatusIDRecall && !this.cancelReason){
      return true;
    }
    else { return false; }
  }

  manageNarratives() {
    const config = new MatDialogConfig();
    config.width = '900px';
    config.height = '560px';
    config.data = {
      ARClaimID: this.ARClaimID,
      PatientId: this.patientId
    };
    config.panelClass = 'dialog';

    const imagePicker = this.dialog.open(NarrativeNoteDialogComponent, config);
    imagePicker.afterClosed().subscribe(result => {
      // results returned
      this.arService.getClaimAttachements(this.ARClaimID).subscribe((resNarrative) => {
        const resultAttachments = resNarrative;
        if (resultAttachments) {
          this.dataClaimAttachments = resultAttachments;
          this.numNarrativesSent = this.dataClaimAttachments.filter(b => b.enumClaimAttachmentTypeID === this.enumClaimAttachmentTypeNarrative).length;
        }

        // update claim validation status
        this.updateClaimValidationStatus();
      });
    }, err => {
      // reject(err);
    });
  }

  async refreshAttachments() {
    // get claim data
    const promises: any[] = [
      this.arService.getClaimAttachements(this.ARClaimID).toPromise(),
    ];

    const results: any[] = await Promise.all(promises);
    this.dataClaimAttachments = results[0];
  }

  protected readonly ClaimStatusEnum = ClaimStatusEnum;

  editClaimItemComment() {
    this.ClaimItemCommentEdit = true;
  }

  saveClaimItemComment() {
    if (this.ClaimItemComment.length > 80) {
      this.createMessage(`Comment exceeds allowed length (max:80, current:${this.ClaimItemComment.length}).`, 'Error');
      return;
    }
    this.ClaimItemCommentEdit = false;

    // send change to server
    const updateObj = new UpdateClaimItemCommentModel();
    updateObj.ARClaimItemID = this.ClaimItemCommentClaimItemID;
    updateObj.Comment = this.ClaimItemComment;

    this.arService.saveClaimItemComment(updateObj)
      .subscribe(response => {
          // read response
          if (response === 1) {
            // save successful
            this.createMessage('Comment Saved', 'Success');

            // update local
            this.dataClaimItems.forEach(a => {
              if (a.ARClaimItemID == updateObj.ARClaimItemID) {
                a.Comment = updateObj.Comment;
              }
            });

            // update claim validation status
            this.updateClaimValidationStatus();
          }
          else {
            // error saving comment
            this.createMessage('Problem saving comment', 'Error');
          }
        },
        err => {
          // error saving comment
          this.createMessage('Problem saving comment', 'Error');
        });
  }

  updateClaimValidationStatus() {
    this.arService.getClaimValidationStatus(this.ARClaimID)
      .subscribe(response => {
          // read response
          if (response.length > 0) {
            // update local claim validation status
            this.enumClaimCheckStatusID = response;
          }
          else {
            // error saving comment
            this.createMessage('Problem getting claim validation status', 'Error');
          }
        },
        err => {
          // error saving comment
          this.createMessage('Problem getting claim validation status', 'Error');
        });
  }
}
